// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const turkey = defineModel({
  id: "turkey",
  batchId: "future",
  name: "Turkey",
  tags: ["creature","turkey","low-poly","age-of-mcp","future"],
  summary: "A turkey — meat and feathers around the farm.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.05, 4), color: "#b08a4a", position: [0.01, 0.025, 0.018] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.05, 4), color: "#b08a4a", position: [0.01, 0.025, -0.018] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#4a3a2c", position: [0, 0.085, 0], scale: [1.25, 1.1, 1.05] },
      { geometry: new THREE.CylinderGeometry(0.075, 0.075, 0.01, 12, 1, false, 0, 3.141593), color: "#3e2f22", position: [-0.06, 0.12, 0], rotation: [-0.5, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.078, 0.078, 0.006, 12, 1, false, 0, 3.141593), color: "#7a6048", position: [-0.066, 0.125, 0], rotation: [-0.5, 1.570796, 0], scale: [1, 1, 0.4] },
      { geometry: new THREE.CylinderGeometry(0.01, 0.013, 0.04, 5), color: "#5c4a38", position: [0.05, 0.115, 0], rotation: [0, 0, -0.4] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#5c4a38", position: [0.07, 0.14, 0] },
      { geometry: new THREE.ConeGeometry(0.006, 0.016, 4), color: "#d8b24a", position: [0.085, 0.138, 0], rotation: [0, 0, -1.5] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#c33a2c", position: [0.082, 0.122, 0], rotation: [0, 0, 3.141593] },
      { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#c33a2c", position: [0.07, 0.128, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#181410", position: [0.078, 0.146, 0.011] },
      { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#181410", position: [0.078, 0.146, -0.011] },
    ],
  animations: [],
});
